/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getPrivateNote = /* GraphQL */ `
  query GetPrivateNote($id: ID!) {
    getPrivateNote(id: $id) {
      id
      content
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listPrivateNotes = /* GraphQL */ `
  query ListPrivateNotes(
    $filter: ModelPrivateNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPrivateNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      id
      no
      description
      image_path
      quiz_image_path
      time_limit
      createdAt
      updatedAt
    }
  }
`;
export const listCategorys = /* GraphQL */ `
  query ListCategorys(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        no
        description
        image_path
        quiz_image_path
        time_limit
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getQuiz = /* GraphQL */ `
  query GetQuiz($id: ID!) {
    getQuiz(id: $id) {
      id
      no
      catergoryId
      question
      image_path
      answer
      choices01
      choices02
      choices03
      choices04
      choices05
      points
      practice_flg
      createdAt
      updatedAt
    }
  }
`;
export const listQuizs = /* GraphQL */ `
  query ListQuizs(
    $filter: ModelQuizFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuizs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        no
        catergoryId
        question
        image_path
        answer
        choices01
        choices02
        choices03
        choices04
        choices05
        points
        practice_flg
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAnswer = /* GraphQL */ `
  query GetAnswer($id: ID!) {
    getAnswer(id: $id) {
      id
      userId
      quizId
      answer
      quiz {
        id
        no
        catergoryId
        question
        image_path
        answer
        choices01
        choices02
        choices03
        choices04
        choices05
        points
        practice_flg
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAnswers = /* GraphQL */ `
  query ListAnswers(
    $filter: ModelAnswerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnswers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        quizId
        answer
        quiz {
          id
          no
          catergoryId
          question
          image_path
          answer
          choices01
          choices02
          choices03
          choices04
          choices05
          points
          practice_flg
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const categoryByNo = /* GraphQL */ `
  query CategoryByNo(
    $no: Int
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    categoryByNo(
      no: $no
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        no
        description
        image_path
        quiz_image_path
        time_limit
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const quizzesSortedByNo = /* GraphQL */ `
  query QuizzesSortedByNo(
    $catergoryId: ID
    $no: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuizFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quizzesSortedByNo(
      catergoryId: $catergoryId
      no: $no
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        no
        catergoryId
        question
        image_path
        answer
        choices01
        choices02
        choices03
        choices04
        choices05
        points
        practice_flg
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const answerByUserId = /* GraphQL */ `
  query AnswerByUserId(
    $userId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelAnswerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    answerByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        quizId
        answer
        quiz {
          id
          no
          catergoryId
          question
          image_path
          answer
          choices01
          choices02
          choices03
          choices04
          choices05
          points
          practice_flg
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
